import Vue from 'vue';
import { AnnouncementsHttpSvc } from '@SharedHttpServices/announcements.httpservice';

const app = new Vue({
    el: '#announcements-vue-container',
    data: {
        selectedAnnouncement: null
    },
    methods: {
        openArticle: function (articleId) {

            AnnouncementsHttpSvc.AnnouncementSelect(articleId)
                .done(response => {
                    this.selectedAnnouncement = response;
                    $('#announcement-details-dialog').modal('show');
                });
        }
    }
});


